import { useTranslation } from "react-i18next";
import { getSiteConfig } from "@/config/siteConfigs";
import { useCookieContext } from "../../context/CookieContext";
import styles from "./Footer.module.scss";

const Footer = () => {
  const { t } = useTranslation("common");
  const { openBanner } = useCookieContext();
  const siteConfig = getSiteConfig();
  const contactInfo = siteConfig.contact;
  const socialLinks = siteConfig.social;

  return (
    <div className="container section">
      <footer
        className={`${styles.footer} sectionContainer sectionContainerWhite`}
      >
        <div className={styles.footerBlocks}>
          <div className={styles.leftBlock}>
            <a className={styles.phone} href={`tel:${contactInfo.phone}`}>
              {contactInfo.phone}
            </a>
            <p className={`textBasic ${styles.mail}`}>{contactInfo.email}</p>
            <p className="textBasic">{contactInfo.address}</p>
            <div className={styles.socials}>
              <a
                href={socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("footer.socialMedia.facebook")}
              >
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <g clipPath="url(#clip0_390_625)">
                    <path d="M17.3431 30V19.455H20.8384L21.5029 15.0915H17.3431V12.2604C17.3431 11.0677 17.9232 9.90257 19.7879 9.90257H21.6801V6.18859C21.6801 6.18859 19.963 5.89359 18.3219 5.89359C14.8962 5.89359 12.656 7.98191 12.656 11.7659V15.0915H8.84644V19.455H12.656V29.9999C5.48513 28.8677 0 22.6241 0 15.0915C0 6.7567 6.71573 0 15 0C23.2843 0 30 6.7567 30 15.0915C30 22.6244 24.5144 28.8682 17.3431 30Z"></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_390_625">
                      <rect width="30" height="30" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </a>
              <a
                href={socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("footer.socialMedia.instagram")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.21 29.264c.644.252 1.613.549 3.397.63 1.929.09 2.508.106 7.393.106 4.886 0 5.465-.018 7.394-.106 1.784-.081 2.753-.378 3.398-.63a5.676 5.676 0 0 0 2.104-1.368 5.673 5.673 0 0 0 1.368-2.104c.25-.644.549-1.613.63-3.397.088-1.93.106-2.51.106-7.395 0-4.886-.018-5.463-.106-7.394-.081-1.784-.378-2.753-.63-3.398-.332-.854-.727-1.464-1.368-2.104A5.663 5.663 0 0 0 25.792.736c-.647-.25-1.614-.549-3.398-.63C20.464.02 19.886 0 15 0c-4.885 0-5.464.018-7.394.106-1.784.081-2.753.378-3.398.63a5.649 5.649 0 0 0-2.104 1.368A5.707 5.707 0 0 0 .736 4.21c-.25.647-.549 1.614-.63 3.398C.02 9.537 0 10.115 0 15.001s.018 5.465.107 7.394c.081 1.784.378 2.753.63 3.398.33.854.727 1.463 1.368 2.103a5.684 5.684 0 0 0 2.104 1.368ZM15 11.666a3.333 3.333 0 1 0 .001 6.667 3.333 3.333 0 0 0 0-6.667Zm0 8.469a5.135 5.135 0 1 1 0-10.27 5.135 5.135 0 0 1 0 10.27Zm4.34-9.807a1.2 1.2 0 0 1 .999-1.866 1.2 1.2 0 1 1-.998 1.866ZM9.104 22.796c.352.137.882.3 1.857.344 1.054.049 1.37.058 4.04.058 2.671 0 2.988-.01 4.042-.058.975-.044 1.505-.207 1.857-.344a3.11 3.11 0 0 0 1.15-.748 3.1 3.1 0 0 0 .748-1.15c.137-.352.3-.881.344-1.857.049-1.054.058-1.37.058-4.04 0-2.671-.01-2.987-.058-4.042-.044-.975-.206-1.505-.344-1.857a3.1 3.1 0 0 0-.748-1.15 3.099 3.099 0 0 0-1.15-.748c-.353-.136-.882-.3-1.857-.344-1.055-.048-1.372-.058-4.042-.058-2.669 0-2.986.01-4.04.058-.975.044-1.505.206-1.857.344-.468.18-.8.397-1.15.748-.35.35-.566.683-.748 1.15-.136.353-.3.882-.344 1.857-.048 1.055-.058 1.37-.058 4.041 0 2.67.01 2.987.058 4.041.044.975.207 1.505.344 1.857.18.467.398.8.748 1.15.35.35.683.566 1.15.748ZM8.45 5.525c.635-.247 1.363-.416 2.427-.464C11.946 5.01 12.288 5 15.003 5s3.056.012 4.122.06c1.064.048 1.791.218 2.428.465a4.893 4.893 0 0 1 1.77 1.153 4.917 4.917 0 0 1 1.154 1.772c.247.635.416 1.363.464 2.427.049 1.066.06 1.407.06 4.123s-.011 3.056-.06 4.123c-.047 1.064-.217 1.791-.464 2.427a4.9 4.9 0 0 1-1.154 1.771 4.918 4.918 0 0 1-1.771 1.154c-.636.247-1.363.416-2.428.464-1.066.05-1.407.061-4.123.061-2.715 0-3.056-.012-4.123-.06-1.064-.049-1.79-.218-2.427-.465a4.913 4.913 0 0 1-1.771-1.154 4.888 4.888 0 0 1-1.154-1.77c-.247-.637-.416-1.364-.464-2.428C5.01 18.057 5 17.716 5 15s.011-3.057.06-4.123c.049-1.064.218-1.791.465-2.427A4.882 4.882 0 0 1 6.68 6.678 4.908 4.908 0 0 1 8.45 5.525Z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </a>
              <a
                href={socialLinks.telegram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("footer.socialMedia.telegram")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="none"
                  aria-hidden="true"
                >
                  <path d="M 12 0 C 6.343 0 3.5158125 0.0008125 1.7578125 1.7578125 C 0.0008125 3.5158125 2.9605947e-16 6.343 0 12 L 0 18 C 0 23.657 0.0008125 26.484188 1.7578125 28.242188 C 3.5158125 29.999188 6.343 30 12 30 L 18 30 C 23.657 30 26.484187 29.999188 28.242188 28.242188 C 29.999187 26.484188 30 23.657 30 18 L 30 12 C 30 6.343 29.999188 3.5158125 28.242188 1.7578125 C 26.484188 0.0008125 23.657 2.9605947e-16 18 0 L 12 0 z M 24.095703 6.6132812 C 24.713913 6.5912562 25.182507 7.1503486 24.931641 8.15625 L 21.914062 22.373047 C 21.703228 23.384257 21.095385 23.624838 20.248047 23.158203 L 15.652344 19.763672 L 13.443359 21.912109 C 13.18556 22.160914 12.983078 22.371094 12.523438 22.371094 L 12.835938 17.683594 L 12.835938 17.681641 L 21.363281 9.9863281 C 21.736989 9.6545874 21.282767 9.4921585 20.785156 9.7949219 L 10.259766 16.435547 L 5.7128906 15.015625 C 4.7326566 14.71486 4.7245387 14.040308 5.9335938 13.554688 L 23.650391 6.7226562 C 23.80196 6.6540848 23.953039 6.6183639 24.095703 6.6132812 z "></path>
                </svg>
              </a>
              <a
                href={socialLinks.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("footer.socialMedia.whatsapp")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="none"
                  aria-hidden="true"
                >
                  <path d="M 12 0 C 6.343 0 3.5158125 0.0008125 1.7578125 1.7578125 C 0.0008125 3.5158125 2.9605947e-16 6.343 0 12 L 0 18 C 0 23.657 0.0008125 26.484188 1.7578125 28.242188 C 3.5158125 29.999188 6.343 30 12 30 L 18 30 C 23.657 30 26.484187 29.999188 28.242188 28.242188 C 29.999187 26.484188 30 23.657 30 18 L 30 12 C 30 6.343 29.999188 3.5158125 28.242188 1.7578125 C 26.484188 0.0008125 23.657 2.9605947e-16 18 0 L 12 0 z M 15.042969 4.953125 A 9.8934908 9.8934908 0 0 1 22.085938 7.8730469 A 9.9012557 9.9012557 0 0 1 25 14.916016 C 24.997782 20.406854 20.530479 24.875 15.042969 24.875 L 15.037109 24.875 A 9.962265 9.962265 0 0 1 10.279297 23.662109 L 5 25.046875 L 6.4121094 19.888672 C 5.5413402 18.37786 5.0839844 16.665005 5.0839844 14.910156 C 5.0862029 9.4193187 9.5543496 4.953125 15.042969 4.953125 z M 15.044922 6.6347656 C 10.479207 6.6347656 6.767845 10.34666 6.765625 14.910156 A 8.2617692 8.2617692 0 0 0 8.03125 19.314453 L 8.2265625 19.626953 L 7.390625 22.681641 L 10.523438 21.859375 L 10.826172 22.039062 A 8.2595507 8.2595507 0 0 0 15.039062 23.193359 L 15.042969 23.193359 C 19.604247 23.193359 23.316159 19.479513 23.318359 14.916016 A 8.2307099 8.2307099 0 0 0 20.896484 9.0605469 A 8.2229451 8.2229451 0 0 0 15.044922 6.6347656 z M 11.517578 10.310547 A 10.70436 10.70436 0 0 1 11.992188 10.320312 C 12.145265 10.326968 12.351958 10.261613 12.552734 10.744141 C 12.760166 11.242199 13.258192 12.468403 13.320312 12.59375 C 13.383543 12.717987 13.423034 12.862908 13.339844 13.029297 C 13.25665 13.195686 13.216034 13.298046 13.091797 13.443359 C 12.96756 13.588672 12.830785 13.76798 12.71875 13.878906 C 12.593403 14.003143 12.464062 14.139089 12.609375 14.388672 C 12.754688 14.638256 13.254265 15.451318 13.994141 16.111328 C 14.944777 16.958802 15.745666 17.221466 15.994141 17.345703 C 16.242615 17.469938 16.38789 17.449592 16.533203 17.283203 C 16.678516 17.116814 17.155877 16.557068 17.322266 16.308594 C 17.488655 16.06012 17.655414 16.102357 17.882812 16.185547 C 18.111321 16.268741 19.332447 16.868794 19.582031 16.994141 C 19.829396 17.118378 19.996474 17.182839 20.058594 17.287109 C 20.120712 17.39138 20.121493 17.88945 19.914062 18.470703 C 19.706631 19.051955 18.712466 19.581354 18.234375 19.652344 C 17.805091 19.715576 17.263642 19.742417 16.667969 19.552734 C 16.30746 19.437371 15.84261 19.285536 15.248047 19.029297 C 12.752211 17.951096 11.122284 15.437873 10.998047 15.271484 C 10.87381 15.105095 9.9824219 13.921889 9.9824219 12.697266 C 9.9824219 11.472643 10.623059 10.870672 10.851562 10.621094 A 0.91624884 0.91624884 0 0 1 11.517578 10.310547 z "></path>
                </svg>
              </a>
            </div>
          </div>

          <div className={styles.rightBlock}>
            <div className={styles.linkBlock}>
              <a className={styles.link} href="/about-us">
                {t("nav.about")}
              </a>
              <a className={styles.link} href="/partners">
                {t("nav.partner")}
              </a>
              <a className={styles.link} href="/career">
                {t("nav.career")}
              </a>
              <a className={styles.link} href="/faq">
                {t("nav.faq")}
              </a>
              <a className={styles.link} href="/contact">
                {t("nav.contact")}
              </a>
            </div>
            <div className={styles.secondBlock}>
              <div className={styles.linkBlock}>
                <a className={styles.link} href="/terms">
                  {t("footer.links.terms")}
                </a>
                <a className={styles.link} href="/shipping">
                  {t("footer.links.shipping")}
                </a>
                <a className={styles.link} href="/cancellation">
                  {t("footer.links.cancellation")}
                </a>
                <a className={styles.link} href="/privacy">
                  {t("footer.links.privacy")}
                </a>
                <a className={styles.link} href="/imprint">
                  {t("footer.links.imprint")}
                </a>
                <a className={styles.link} href="/returns">
                  {t("footer.links.returns")}
                </a>
                <button
                  onClick={openBanner}
                  className={styles.link}
                  aria-label={t("cookies.openSettings")}
                >
                  {t("cookies.openSettings")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.rights}>
          <img
            src="/images/cprght-logo.svg"
            className="brxe-image css-filter size-full"
            alt={t("footer.logoAlt")}
            id="cprght-logo"
            decoding="async"
            loading="lazy"
          />
          <p>{t("footer.copyright")}</p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
